let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hOvDm")).then(() => parcelRequire('l8WCu'));